var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wrapper-base-notification-list" }, [
    _c("div", { staticClass: "header" }, [
      _vm.title
        ? _c("div", [_c("strong", [_vm._v(_vm._s(_vm.title))])])
        : _vm._e(),
      _vm._v(" "),
      _c("div", [
        _vm.isShowReadAllButton
          ? _c(
              "button",
              {
                staticClass: "btn btn-light btn-sm btn-read-all",
                on: {
                  click: function($event) {
                    return _vm.handleClickReadAll()
                  }
                }
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("message.readall")) + "\n      "
                )
              ]
            )
          : _vm._e()
      ])
    ]),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "body" },
      _vm._l(_vm.limitItemList, function(item, index) {
        return _c(
          "li",
          { key: index },
          [_vm._t("item", null, { itemData: item })],
          2
        )
      }),
      0
    ),
    _vm._v(" "),
    _vm.isShowSeeMoreButton
      ? _c("div", { staticClass: "footer" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-light btn-sm",
              on: {
                click: function($event) {
                  return _vm.handleClickSeeMore()
                }
              }
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t("message.seemorewithnumber", {
                      number: _vm.seeMoreCount
                    })
                  ) +
                  "\n    "
              )
            ]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c4d37c50", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c4d37c50","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseNotificationList.vue
// module id = null
// module chunks = 